import cx from 'classnames';
import { prams_and_accessories as pramsAndAccessoriesCategory } from 'mk/autogenerated/bzCategories';
import {
    FROM,
    STROLLER_DETAIL_count_PRODUCTS_IN_BAZAAR,
    STROLLER_DETAIL_GO_TO_BAZAAR,
    STROLLER_DETAIL_WHERE_TO_BUY,
    STROLLER_DETAIL_WHERE_TO_BUY_NEW_MORE_SHOPS,
} from 'mk/autogenerated/translations/StrollerDetailWhereToBuy.8613f8e822ba23b170627aac9a1cdc56'
import { formatPrice } from 'mk/bazaar/common/formatters';
import { bazaar_single_page_product_grid_category_url, strollers_api_v2_eshop_exit_url } from 'mk/urls/functions';
import { ProductEntity, XMLImportItemEntity } from 'mk2/apps/bazaar/schemas';
import { StrollerDetailWhereToBuyListItem } from 'mk2/apps/strollers/containers/StrollersDetail/StrollerDetailWhereToBuyListItem';
import { Btn, BtnType } from 'mk2/components/Btn';
import { ImgCropped, ImgCropMode } from 'mk2/components/ImgCropped';
import { Interpolate } from 'mk2/components/Interpolate';
import { Link } from 'mk2/components/Link';
import { TrackIntersection } from 'mk2/components/TrackIntersection';
import { StrollerEntity } from 'mk2/schemas';
import React from 'react';
import styles from './StrollerDetailWhereToBuy.mscss';

const pramsCategory = pramsAndAccessoriesCategory.find((c) => c.name === 'prams');

interface OwnProps {
    className?: string;
    stroller: StrollerEntity;
    eshopProducts: XMLImportItemEntity[];
    oldProductsCount: number;
    cheapestOldProduct: ProductEntity;
    isAdmin: boolean;
    isMobile: boolean;
    onStoreEvent(name: string, props: any, redirect?: string);
}

type Props = OwnProps;

interface State {
    showAllEshops: boolean;
}

export class StrollerDetailWhereToBuy extends React.Component<Props, State> {
    public state: State = {
        showAllEshops: false,
    };

    public render() {
        const { className, stroller, oldProductsCount, cheapestOldProduct, eshopProducts, isAdmin, isMobile } = this.props;

        if (eshopProducts.length === 0 && !cheapestOldProduct) {
            return null;
        }

        return (
            <div className={cx(className, styles.StrollerDetailWhereToBuy)}>
                <h2 className={styles.StrollerDetailWhereToBuy__headline}>{STROLLER_DETAIL_WHERE_TO_BUY}</h2>

                {(eshopProducts.length > 0) && (
                        <TrackIntersection
                            visibilityRatio={0.5}
                            callbackDelay={1000}
                            onVisibilityCallback={this.onVisibilityCallbackAllEshops}
                        >
                        <div className={styles.StrollerDetailWhereToBuy__newProducts}>
                            <ul className={styles.StrollerDetailWhereToBuy__newProductsList}>
                                {(this.state.showAllEshops ? eshopProducts : eshopProducts.slice(0, 3))?.map((item, index) => (
                                    <li key={`eshop-product-${item.id}`}>
                                        <StrollerDetailWhereToBuyListItem
                                            logo={item.xmlImportFeed.eshopLogoPhoto}
                                            productUrl={strollers_api_v2_eshop_exit_url(stroller.id, item.id, {pos: index})}
                                            productName={item.current.title}
                                            price={item.current.price}
                                            originalPrice={item.current.originalPrice}
                                            isAdmin={isAdmin}
                                            inStock
                                            isMobile={isMobile}
                                            isLast
                                        />
                                    </li>
                                ))}
                            </ul>
                            {eshopProducts.length > 3 && (
                                <div className={styles.StrollerDetailWhereToBuy__newProductsFooter}>
                                    {eshopProducts.length > 3 && !this.state.showAllEshops && (
                                        <button
                                            className={styles.StrollerDetailWhereToBuy__newProductsMoreShops}
                                            onClick={this.onShowAllEshopsClick}
                                            type="button"
                                        >
                                            {STROLLER_DETAIL_WHERE_TO_BUY_NEW_MORE_SHOPS} (
                                            {eshopProducts.length - 3})
                                        </button>
                                    )}
                                </div>
                            )}
                        </div>
                    </TrackIntersection>
                )}

                {cheapestOldProduct && (
                    <div className={styles.StrollerDetailWhereToBuy__oldProduct}>
                        <Link
                            className={styles.StrollerDetailWhereToBuy__oldProductLink}
                            to={bazaar_single_page_product_grid_category_url(pramsCategory.slug, {
                                BRAND_MODEL: stroller.name,
                                quality: 'old',
                                sort: 'price',
                            })}
                        >
                            <div className={styles.StrollerDetailWhereToBuy__oldProductImage}>
                                <ImgCropped
                                    photo={cheapestOldProduct.photos[0].photofile}
                                    photoVersion="s221x221"
                                    width={64}
                                    height={64}
                                    mode={ImgCropMode.Cover}
                                />
                            </div>
                            <div className={styles.StrollerDetailWhereToBuy__oldProductInfo}>
                                <Interpolate
                                    className={styles.StrollerDetailWhereToBuy__oldProductInfoCount}
                                    i18nKey={STROLLER_DETAIL_count_PRODUCTS_IN_BAZAAR}
                                    count={oldProductsCount}
                                    parent="div"
                                />
                                <div className={styles.StrollerDetailWhereToBuy__oldProductInfoPrice}>
                                    {oldProductsCount > 1 ? `${FROM.toLowerCase()} ` : null}
                                    {formatPrice(cheapestOldProduct.price)}
                                </div>
                            </div>
                        </Link>
                        <Btn
                            type={BtnType.Blue}
                            label={STROLLER_DETAIL_GO_TO_BAZAAR}
                            link={bazaar_single_page_product_grid_category_url(pramsCategory.slug, {
                                BRAND_MODEL: stroller.name,
                                quality: 'old',
                                sort: 'price',
                            })}
                        />
                    </div>
                )}
            </div>
        );
    }

    private onShowAllEshopsClick = () => {
        this.setState({
            showAllEshops: true,
        });

        this.props.onStoreEvent('stroller_detail_click_section', {
            section: 'show_all_eshops',
            stroller_id: this.props.stroller.id,
            stroller_name: this.props.stroller.name,
            stroller_slug: this.props.stroller.slug,
            brand_id: this.props.stroller.brand.id,
            brand_name: this.props.stroller.brand.name,
            brand_slug: this.props.stroller.brand.slug,
            is_admin: this.props.isAdmin,
        });
    };

    private onVisibilityCallbackAllEshops = () => {
        this.props.onStoreEvent('stroller_detail_visible_section', {
            section: 'eshops',
            stroller_id: this.props.stroller.id,
            stroller_name: this.props.stroller.name,
            stroller_slug: this.props.stroller.slug,
            brand_id: this.props.stroller.brand.id,
            brand_name: this.props.stroller.brand.name,
            brand_slug: this.props.stroller.brand.slug,
            is_admin: this.props.isAdmin,
        });
    };

}
